import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Callout, IconButton, DirectionalHint } from '@fluentui/react';
import { callOutStyles } from './styles';
import { FrequencyEditPanel } from './frequency-edit-panel';

// Feel free to export more functions if you need
// like dismissCallback, iconClickCallback, cancelCallback ...
function ScheduleFrequencyIconEditor(props) {
  const {
    className,
    onSchedulerSaveClick,
    data,
    calloutProps,
  } = props;


  const [isCalloutVisible, setIsCalloutVisible] = useState(false);

  const i18n = useContext(I18nContext);

  function toggleIsCalloutVisible() {
    setIsCalloutVisible(pre => !pre);
  }

  function onSchedulerDismiss() {
    toggleIsCalloutVisible();
  }

  function onSchedulerIconClicked() {
    toggleIsCalloutVisible();
  }

  async function onSaveClick(settings) {
    try {
      await onSchedulerSaveClick(settings);
      toggleIsCalloutVisible();
    } catch (e) {
      // pass eslint
    }
  }

  function onCancelClick() {
    toggleIsCalloutVisible();
  }

  return (
    <span className={`${className} scheduler-icon`}>
      <IconButton title={i18n.getString(_TL_('Schedule'))} styles={{ root: { width: 16, height: 16 } }} id="scheduler-edit" iconProps={{ iconName: 'Edit' }} onClick={onSchedulerIconClicked} />
      {isCalloutVisible &&
        <Callout
          onDismiss={onSchedulerDismiss}
          isBeakVisible={false}
          styles={callOutStyles}
          directionalHint={DirectionalHint.bottomAutoEdge}
          {...calloutProps}
        >
          <FrequencyEditPanel
            data={data}
            onSave={onSaveClick}
            onCancel={onCancelClick}
          />
        </Callout>
      }
    </span>
  );
}

ScheduleFrequencyIconEditor.propTypes = {
  className: PropTypes.string,
  onSchedulerSaveClick: PropTypes.func.isRequired,
  data: PropTypes.shape({
    isScheduleEnabled: PropTypes.bool.isRequired,
    AttachFileToEmail: PropTypes.bool.isRequired,
    EmailRecipients: PropTypes.arrayOf(PropTypes.string).isRequired,
    Cron: PropTypes.string.isRequired,
    StartDate: PropTypes.string.isRequired,
    EndDate: PropTypes.string.isRequired,
    Template: PropTypes.string.isRequired,
    FileFormat: PropTypes.string.isRequired,
  }).isRequired,
  calloutProps: PropTypes.shape({}),
};

ScheduleFrequencyIconEditor.defaultProps = {
  className: '',
  calloutProps: {},
};

export { ScheduleFrequencyIconEditor };
